import { apiV2 } from "../v2";
import {
  adminAuthorKey,
  getAdminAuthorResponse,
  getAdminAuthorStatsResponse,
  listAdminAuthorsRequest,
  listAdminAuthorsResponse,
  updateAdminAuthorImageRequest,
} from "./authors.dto";

export const listAdminAuthorsApi = apiV2("GET", "/admin/authors").withRequest(listAdminAuthorsRequest).withResponse(listAdminAuthorsResponse);

export const getAdminAuthorApi = apiV2("GET", "/admin/authors/:alias").withRequest(adminAuthorKey).withResponse(getAdminAuthorResponse);

export const updateAdminAuthorImageApi = apiV2("PATCH", "/admin/authors/:alias/profile-image")
  .withRequest(updateAdminAuthorImageRequest)
  .withResponse(getAdminAuthorResponse);

export const getAdminAuthorStatsSummaryApi = apiV2("GET", "/admin/authors/:alias/stats").withRequest(adminAuthorKey).withResponse(getAdminAuthorStatsResponse);
